/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SearchPartnerRequest {
  /**
   * Partner first name
   */
  firstName: string;
  /**
   * Partner last name
   */
  lastName: string;
  /**
   * Partner date of birth. Any format that can be parsed by ```js new Date(dateOfBirth) ``` (Type-/JavaScript)
   */
  dateOfBirth: string;
  /**
   * Postal code of partner main address
   */
  postCode: string;
  /**
   * Partner main Email address
   */
  email: string;
}
